import $http from '@/resource';
import utils from '@/utils';
import {Message, Notice} from 'view-design';

const $api = {};


/**
 * 名片统计列表
 *
 * @param {array} searchData 搜索条件
 *
 * @returns {Promise<any>}
 */
$api.getCardStatistics = function(searchData) {
	const url = 'card-statistics';
	const promise = new Promise(function(resolve){
		$http.get(url, {params: searchData}).then(function (response) {
		  	if (response.code == 200) {
		  	  	resolve(response);
		  	}else{
		  		utils.notice(response.msg, 'error');
		  	}
		});
	});
  	return promise;
}

export default $api; 


// WEBPACK FOOTER //
// ./src/service/usercenter/businessCards.js